/* eslint-disable camelcase */

export default api => {
  function getOrdersV2(query) {
    return api.get(`/_svc/slapi-v1/orders_v2?${query}`);
  }

  function getSingleOrder(query) {
    return api.get(`/_svc/slapi-v1/orders_v2/item?${query}`);
  }

  function openPickup(warehouse: Object) {
    return api.post(`/_svc/slapi-v1/pickup/open`, warehouse);
  }

  function getOrderCount(query) {
    return api.get(`/_svc/slapi-v1/orders_v2/count?${query}`);
  }

  function postPickupV2(query, remove) {
    return api.post(
      `/_svc/slapi-v1/pickup/${remove ? "remove/" : ""}items`,
      query
    );
  }

  function postOrdersV2(orders: Object) {
    return api.post(`/_svc/slapi-v1/orders_v2/action`, orders);
  }

  function getOrders(query) {
    return api.get(`/_svc/slapi-v1/orders?${query}`);
  }

  function getReservedOrders(query) {
    return api.get(`/_svc/slapi-v1/reserveditems`);
  }

  function postOrders(orders: Object) {
    return api.post(`/_svc/slapi-v1/order/action`, orders);
  }

  function printOrder(query) {
    return window.open(`/_svc/slapi-v1/order/invoice?${query}`);
  }

  return {
    getOrdersV2,
    postOrdersV2,
    postPickupV2,
    getOrders,
    postOrders,
    getReservedOrders,
    printOrder,
    getOrderCount,
    getSingleOrder,
    openPickup
  };
};



// WEBPACK FOOTER //
// ./src/services/OrdersService.js